import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';


class ScheduleGradeRequestsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect_url: false,
      loaded: 0,
      staff_schedule_request_id: null,
      manager_answer_reason: null,
      modal: false,
      staff_schedule_requests: this.props.staff_schedule_requests,
    };

    this.reproveModal = this.reproveModal.bind(this);
    this.reprove = this.reprove.bind(this);
    this.approve = this.approve.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && Array.isArray(newProps.staff_schedule_requests)) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        staff_schedule_requests: newProps.staff_schedule_requests,
        loaded: 1,
      });
    }
  }

  ActionsButtons (cell, row) {
    botao = (<div></div>);

    if(row.status === 1) {
      var botao = (
        <div className="btn-group">
          <button className="btn btn-sm btn-success" value={cell} onClick={() => this.approve(cell)}>
            <i className="fa fa-fw fa-check"></i>
          </button>
          <button className="btn btn-sm btn-danger" value={cell} onClick={() => this.reproveModal(cell)}>
            <i className="fa fa-fw fa-close"></i>
          </button>
        </div>
      );
    }

    return botao;
  }

  reproveModal (staff_schedule_request_id) {
    var confirm = window.confirm(this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.reprovar);
    if (confirm) {
        this.setState({staff_schedule_request_id: staff_schedule_request_id, modal: true, manager_answer_reason: null});
    }
  }

  reprove (event) {
    event.preventDefault();

    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    var datasave = {
        id: this.state.staff_schedule_request_id,
        manager_answer_reason: this.state.manager_answer_reason,
        schedule_id: self.props.schedule_id,
    };

    Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/reprovacao/gestor/alteracao/escala', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.setState({staff_schedule_requests: responseJson.data});
              self.setState({staff_schedule_request_id: null, modal: false, manager_answer_reason: null});
            }
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
            console.error(error);
        });
    });
  }

  approve (staff_schedule_request_id) {
    var confirm = window.confirm(this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.aprovar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var datasave = {
        id: staff_schedule_request_id,
        schedule_id: self.props.schedule_id,
      };

      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aprovacao/gestor/alteracao/escala', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({staff_schedule_requests: responseJson.data});
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  
  

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.props.handleLoaded} />
  <h3 className="page-title">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.tituloSolicitacoesDeTripulantes}</h3>
  <hr/>
  {(this.state.staff_schedule_requests === null || typeof this.state.staff_schedule_requests === 'undefined') ?  <div><small><em>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.naohaSolicitacoes}</em></small><hr/></div> 
  : 
    <div>
        <BootstrapTable data={this.state.staff_schedule_requests} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.tabela.semSolicitacoes}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

            <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='120'>Ações</TableHeaderColumn>
            <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.tabela.ID}</TableHeaderColumn>
            <TableHeaderColumn dataField="creation_date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.tabela.DataDeCriacao}</TableHeaderColumn>
            <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='300'>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.tabela.NomeDoColaborador}</TableHeaderColumn>
            <TableHeaderColumn dataField="start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.tabela.Inicio}</TableHeaderColumn>
            <TableHeaderColumn dataField="finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.tabela.Fim}</TableHeaderColumn>
            <TableHeaderColumn dataField="reason" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='500'>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.tabela.Justificativa}</TableHeaderColumn>
            <TableHeaderColumn dataField="fleet_chief_answer_date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.tabela.ChefeDeFrotaDataResposta}</TableHeaderColumn>
            <TableHeaderColumn dataField="fleet_chief_answer_reason" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='500'>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.tabela.ChefeDeFrotaJustificativa}</TableHeaderColumn>

        </BootstrapTable>
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
            <Modal.Header>
                <h4 className="pull-left">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.tituloJustifiqueAReprovacao}</h4>
                <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ staff_schedule_request_id: null, modal: false, manager_answer_reason: null })}>
                <i className="fa fa-fw fa-close"></i></button>
                <div className="clearfix"></div>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={this.reprove}>
                <div className="form-group">
                    <textarea style={{ height: 150 }} type="text" name="manager_answer_reason" className="form-control" value={this.state.manager_answer_reason} onChange={this.handleChange.bind(this, 'manager_answer_reason')} required />
                </div>
                <div className="form-group">
                    <button type={'submit'} className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.formulario.botaoJustificar}</button>
                </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ staff_schedule_request_id: null, modal: false, manager_answer_reason: null })}>
                <i className="fa fa-fw fa-close"></i></button>
            </Modal.Footer>
        </Modal>
    </div>
  }

</div>
    );
  }
}


export default ScheduleGradeRequestsTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeRequestsTab.js